// @mui
import { alpha } from '@mui/material/styles';
// theme
import { palette as themePalette } from 'src/theme/palette';

// ----------------------------------------------------------------------

export function presets(presetsColor) {
  const primary = primaryPresets.find((i) => i.name === presetsColor);

  const theme = {
    palette: {
      primary,
    },
    customShadows: {
      primary: `0 8px 16px 0 ${alpha(`${primary?.main}`, 0.24)}`,
    },
  };

  return theme;
}

// ----------------------------------------------------------------------

const palette = themePalette('light');

export const primaryPresets = [
  // DEFAULT
  {
    name: 'default',
    ...palette.primary,
  },
  // CYAN
  {
    name: 'cyan',
    lighter: '#000',
    light: '#000',
    main: '#000',
    dark: '#000',
    darker: '#000',
    contrastText: '#fff',
  },
  // PURPLE
 {
    name: "purple",
"lighter": "#D3FCD2",
    "light": "#77ED8B",
    "main": "#22C55E",
    "dark": "#118D57",
    "darker": "#065E49",
    "contrastText": "#FFFFFF"
  },
  
  // BLUE
  {
    name: 'blue',
    lighter: '	#cfecf7',
    light: '	#a0d9ef',
    main: '#00b1ff',
    dark: '#20a7db',
    darker: '#1c96c5',
    contrastText: '#FFFFFF',
  },
  // ORANGE
  {
    name: 'orange',
    lighter: '#FEF4D4',
    light: '#FED680',
    main: '#fda92d',
    dark: '#B66816',
    darker: '#793908',
    contrastText: palette.grey[800],
  },
  // RED
  {
    name: 'red',
    lighter: '#FFE3D5',
    light: '#FFC1AC',
    main: '#FF3030',
    dark: '#B71833',
    darker: '#7A0930',
    contrastText: '#FFFFFF',
  },
];
